import React, { Component } from 'react';
import { translate } from 'react-i18next';

import HelpLayout from 'components/HelpLayout/HelpLayout';

class Help extends Component {

  render() {
    const param = window.location.href.indexOf('node=') > -1 ? window.location.href.split('node=')[1].split('&')[0] : undefined;

    return (
      <div className='app-container'>
        <HelpLayout history={this.props.history} node={param}/>
      </div>
    );
  }
}

export default translate()(Help);
